import { render } from "./FeedbackPopUpCard.vue?vue&type=template&id=716968fa&scoped=true"
import script from "./FeedbackPopUpCard.vue?vue&type=script&lang=js"
export * from "./FeedbackPopUpCard.vue?vue&type=script&lang=js"

import "./FeedbackPopUpCard.vue?vue&type=style&index=0&id=716968fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716968fa"]])

export default __exports__